import { render } from "./CombinationsHeader.vue?vue&type=template&id=3cada47c"
import script from "./CombinationsHeader.vue?vue&type=script&lang=js"
export * from "./CombinationsHeader.vue?vue&type=script&lang=js"

import "./CombinationsHeader.vue?vue&type=style&index=0&id=3cada47c&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle});
